import { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { useRenameItem } from './hooks/use_filemanager';

const RenameModal = ({ item, currentPath, onClose, baseApiUrl }) => {
  const [newName, setNewName] = useState(item.name);
  const renameItemMutation = useRenameItem(baseApiUrl);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!newName.trim()) {
      alert('Bitte geben Sie einen Namen ein');
      return;
    }

    if (newName === item.name) {
      onClose();
      return;
    }

    renameItemMutation.mutate(
      { path: item.path, newName: newName.trim(), currentPath },
      {
        onSuccess: () => {
          onClose();
        },
      }
    );
  };

  return (
    <Modal
      isOpen={true}
      onRequestClose={onClose}
      contentLabel="Umbenennen"
      className="modal-dialog"
      overlayClassName="modal-backdrop"
    >
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Umbenennen</h5>
          <button type="button" className="close" onClick={onClose}>
            <span>&times;</span>
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label htmlFor="new-name">Neuer Name</label>
              <input
                type="text"
                id="new-name"
                className="form-control"
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
                autoFocus
              />
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Abbrechen
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={renameItemMutation.isLoading}
            >
              {renameItemMutation.isLoading ? 'Benenne um...' : 'Umbenennen'}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

RenameModal.propTypes = {
  item: PropTypes.object.isRequired,
  currentPath: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  baseApiUrl: PropTypes.string,
};

export default RenameModal;